// extracted by mini-css-extract-plugin
export default {"link":"NavItem_link__X+VsE"};